import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';
import { EEditorUiGetter } from '@/editor/editor-block/store/editor-ui.constants';
import { IEditorUiState } from '@/editor/editor-block/store/editor-ui.types';
import { EContext } from '@/editor/types/enums';

export const getters: GetterTree<IEditorUiState, RootState> = {
  [EEditorUiGetter.Context]({ context }: IEditorUiState): EContext {
    return context;
  },
};
